export enum PredefinedEmissionPlace {
  PRODUCT_PAGE = 'PRODUCT_PAGE',
  LANDING_PAGE = 'LANDING_PAGE',
  MAIN_PAGE = 'MAIN_PAGE',
  SEARCH = 'SEARCH',
  BLOG = 'BLOG',
  SHOPPING_CART = 'SHOPPING_CART',
  OTHER_PLACE = 'OTHER_PLACE',
}
